import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import MovingShowcase from "../components/MovingShowcase";
import TestimonialsSection from "../components/TestimonialsSection";
import BecomeClientSection from "../components/BecomeClientSection";
import ContactSection from "../components/ContactSection";
import { useQuoteContext } from "../context/QuoteContext";

const heroVariants = {
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.4, ease: [0.25, 0.1, 0.25, 1] },
  },
  hidden: {
    opacity: 0,
    y: -60,
    scale: 0.93,
    transition: { duration: 0.4, ease: [0.25, 0.1, 0.25, 1] },
  },
};

export default function Home() {
  const { visible } = useQuoteContext();
  return (
    <>
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="animated-grid absolute inset-0" />

      <motion.div
        variants={heroVariants}
        animate={visible ? "hidden" : "visible"}
        className="relative z-10 flex flex-col items-center text-center px-6 max-w-5xl mx-auto"
      >
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold leading-tight"
        >
          Engineering Secure{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyber-blue to-tech-green">
            Digital Systems
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          className="mt-6 text-gray-400 text-lg md:text-xl max-w-2xl"
        >
          Cybersecurity &middot; Networking &middot; Software &middot; CCTV &middot; ISP Solutions
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <Link
            to="/case-studies"
            className="px-8 py-4 bg-cyber-blue text-black font-bold rounded-lg hover:bg-cyber-blue/90 transition-all hover:scale-105 text-center"
          >
            View Case Studies
          </Link>
          <Link
            to="/contact"
            className="px-8 py-4 glass rounded-lg font-semibold hover:bg-white/10 transition-all hover:scale-105 text-center"
          >
            Contact Us
          </Link>
        </motion.div>
      </motion.div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="w-6 h-10 rounded-full border-2 border-gray-600 flex justify-center pt-2"
        >
          <div className="w-1 h-3 rounded-full bg-gray-400" />
        </motion.div>
      </div>
    </section>
    <MovingShowcase />
    <TestimonialsSection />
    <BecomeClientSection />
    <ContactSection />
    </>);
}
